package com.arenaproplay.admin.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.browser.document

object SeoHelper {
    private fun setMetaTag(name: String, content: String, isProperty: Boolean = false) {
        val selector = if (isProperty) "meta[property='$name']" else "meta[name='$name']"
        val element = document.querySelector(selector)
        if (element != null) {
            element.setAttribute("content", content)
        } else {
            val meta = document.createElement("meta")
            if (isProperty) {
                meta.setAttribute("property", name)
            } else {
                meta.setAttribute("name", name)
            }
            meta.setAttribute("content", content)
            document.head?.appendChild(meta)
        }
    }

    fun updatePageMeta(
        title: String,
        description: String = "",
        ogImage: String = "/og-image.png",
        ogType: String = "website"
    ) {
        document.title = title

        if (description.isNotBlank()) {
            setMetaTag("description", description)
        }

        setMetaTag("og:title", title, isProperty = true)
        setMetaTag("og:type", ogType, isProperty = true)
        if (description.isNotBlank()) {
            setMetaTag("og:description", description, isProperty = true)
        }
        setMetaTag("og:image", ogImage, isProperty = true)

        setMetaTag("twitter:title", title)
        if (description.isNotBlank()) {
            setMetaTag("twitter:description", description)
        }
    }
}

@Composable
fun PageSeo(
    title: String,
    description: String = "",
    ogImage: String = "/og-image.png"
) {
    LaunchedEffect(title, description) {
        SeoHelper.updatePageMeta(
            title = title,
            description = description,
            ogImage = ogImage
        )
    }
}
